import { ChevronLeftIcon, ChevronsRight } from "lucide-react";
import { Link } from "react-router-dom";
import { twMerge } from "tailwind-merge";
import { cn } from "@/common/utils/cn";
import Skeleton from "../Skeleton";
import GoBackButton, { GoBackButtonProps } from "../GoBackButton";

interface ShowHeaderProps {
  className?: string;
  backTo?: string;
  goBack?: boolean;
  goBackProps?: GoBackButtonProps;
  title?: string | JSX.Element;
  titleClassName?: string;
  subtitle?: string | JSX.Element;
  subtitleClassName?: string;
  logoClassName?: string;
  logoUrl?: string;
  LogoPlaceholder?: JSX.Element;
  badge?: JSX.Element;
  buttons?: JSX.Element;
  isLoading?: boolean;
}

export const ShowHeader = ({
  className,
  backTo,
  goBack,
  goBackProps,
  title,
  titleClassName,
  subtitle,
  subtitleClassName,
  logoClassName,
  logoUrl,
  LogoPlaceholder,
  badge,
  buttons,
  isLoading,
}: ShowHeaderProps) => {
  if (isLoading) {
    return (
      <div className="flex items-center gap-2 h-10 mb-6">
        <Skeleton width={250} height={24} />

        <Skeleton width={200} height={24} />
      </div>
    );
  }

  return (
    <div className={cn('flex justify-between items-center gap-3 flex-wrap mb-6', className)}>
      <div className="flex flex-wrap gap-2 items-center">
        {goBack && (
          <GoBackButton {...goBackProps} />
        )}

        {!goBack && backTo && (
          <Link to={backTo} className="cursor-pointer">
            <ChevronLeftIcon size={40} strokeWidth={1} />
          </Link>
        )}

        {logoUrl ? (
          <img
            src={logoUrl}
            alt={typeof title === 'string' ? title : ''}
            className={twMerge('size-8 rounded-full object-cover', logoClassName)}
          />
        ) : LogoPlaceholder ? (
          <>
            {LogoPlaceholder}
          </>
        ) : (
          <></>
        )}

        {title && (
          <>
            <h2 className={twMerge('text-2xl font-bold', titleClassName)}>
              {title}
            </h2>

            {subtitle && (
              <>
                <ChevronsRight className="text-white-400" />

                <h2 className={subtitleClassName}>
                  {subtitle}
                </h2>
              </>
            )}

            {badge}
          </>
        )}
      </div>

      <div className="ml-auto">
        {buttons}
      </div>
    </div>
  );
};
